import _ from 'lodash'
import i18n from 'scoreboard/components/i18n'
import listStreamer from 'scoreboard/reports/common/list-streamer'
import globals from 'scoreboard/components/globals'
import user from 'scoreboard/components/user'
import permissions from 'scoreboard/components/permissions'
import BaseReportModel from 'scoreboard/reports/common/base-report-model'
import constants from 'scoreboard/components/constants'
import conductor from 'scoreboard/components/conductor'
import Xhr from 'scoreboard/components/xhr'

var SqlConsoleModel = BaseReportModel.extend({

	periodSelector: false,
	allowTemplate: false,
	observableProperties: ['label', 'query'],

	defaults: function() {
		let query = conductor.section() == 'admin' ? user.model.get('lastQuery') : ''
		return {
			organizationId: globals.orgId,
			periodId: globals.periodId,
			subtype: 'sql-console',
			type: 'report',
			label: i18n.get('report.sqlConsole.title'),
			query: query || '',
			adminSqlConsole: conductor.section() === 'admin'
		}
	},

	isEditable: function() {
		return permissions.isEditableIfReplicated(this) && (
			permissions.appAdmin() || (permissions.reports(this.get('organizationId')) && permissions.readOnlySqlConsole()))
	},

	initialize: function(attrs = {}, opts) {
		BaseReportModel.prototype.initialize.apply(this, arguments)
		this.stale = true
		this.togglePeriodSelector(attrs.query)
	},

	/**
	 * In #26444 we added support for calendar-period parameters in the query.
	 * #26600 requested that when one or more of these are used that the
	 * period selector become visible.
	 *
	 * Rather than trying to plumb an attribute into the report results/metadata
	 * to indicate this we will just do a search here.
	 *
	 * @see com.spider.cms.report.SqlConsoleService.resolveCalendarVariables
	 */
	togglePeriodSelector: function (query = '') {
		if (query.match(/.*\[calendar-period.*\]/)) {
			this.periodSelector = true
		}
	},

	validate: function(attrs, options) {
		var errors = {}
		if (_.isEmpty(attrs.label)) {
			errors.label = i18n.get('common.error.required', i18n.get('report.title'))
		}
		if (_.isEmpty(attrs.query)) {
			errors.query = i18n.get('common.error.required', i18n.get('report.sqlConosle.query'))
		}
		return this.formatErrors(errors, options)
	},

	/**
	 * @param {string} [options.script] #43222 this is all the text in the sql
	 * editor vs. just the query that will be executed. We use this to save the
	 * state of the sql console between navigation and refreshes
	 */
	fetch: function(options) {
		if (conductor.section() == 'admin') {
			user.model.set('lastQuery', options.script ? options.script : this.get('query'), {silent: true})
		}
		var opts = options || {}

		let data = this.toJSON(options)
		data.periodId = globals.periodId
		data.script = opts.script
		// #54905 populate the existing report id from the cancelAttributes, if
		// present (this is used to check permissions for sql report dashboard
		// widgets based on an existing report)
		data.existingReportId = this.cancelAttributes?.id

		var params = {
			url: this.urlRoot('results'),
			method: 'POST',
			data: JSON.stringify(data),
			contentType: constants.CONTENT_TYPES.APPLICATION_JSON,
			stream: 'results',
			parseForm: (key, attrs) => {
				//update the report form that was sent back.  backend will track whether
				//the query is a select/update statement or not.
				if (key == 'form') {
					this.set(attrs, {silent: true})
					this.metadata = attrs.metadata
				}
			}
		}

		this.initialData = []
		return listStreamer(this, _.assign(opts, params))
	},

	fetchCSV: function(options = {}) {
		let data = this.toJSON(options)
		data.periodId = globals.periodId

		return new Promise((resolve, reject) => {
			const xhr = new Xhr()
			xhr.download({
				url: this.urlRoot('results'),
				method: 'POST',
				headers: {
					Accept: 'text/csv, */*' // */* for exceptions to work
				},
				data: JSON.stringify(data),
				contentType: constants.CONTENT_TYPES.APPLICATION_JSON,
				error: response => reject(xhr)
			}).then(() => resolve(xhr))
		})
	}

})

export default SqlConsoleModel

SqlConsoleModel.__filename__ = 'components/sql-console/sql-console-model.js'
